import { cloneElement, useContext } from "react"
import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import { AccordionContext } from "./AccordionContext"

function GridAccordion({ children, itemsPerRow = 4 }) {
  const numRows = Math.ceil(children.length / itemsPerRow)
  const { openSections } = useContext(AccordionContext)
  const isOpen =
    _.some(openSections) && _.every(Object.keys(openSections), section => children[section])

  return (
    <div className={classNames("oj-grid-accordion", { open: isOpen }, { closed: !isOpen })}>
      {_.times(numRows, id => {
        const rowStart = id * itemsPerRow
        const rowEnd = rowStart + itemsPerRow
        const row = _.slice(children, rowStart, rowEnd)

        return (
          <div className="grid-row" key={`grid-row-${id}`}>
            {_.map(row, (child, index) => {
              const rowIndex = index + rowStart
              return cloneElement(child, {
                index: rowIndex
              })
            })}
          </div>
        )
      })}
    </div>
  )
}

GridAccordion.propTypes = {
  children: PropTypes.node.isRequired,
  refs: PropTypes.shape({
    current: PropTypes.arrayOf(
      PropTypes.shape({
        current: PropTypes.instanceOf(Element)
      })
    )
  }),
  itemsPerRow: PropTypes.number
}

export default GridAccordion
